import { render, staticRenderFns } from "./DictionaryWordsTabs.vue?vue&type=template&id=5b2c4820&scoped=true&"
import script from "./DictionaryWordsTabs.vue?vue&type=script&lang=js&"
export * from "./DictionaryWordsTabs.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryWordsTabs.vue?vue&type=style&index=0&id=5b2c4820&scoped=true&lang=scss&"
import style1 from "./DictionaryWordsTabs.vue?vue&type=style&index=1&id=5b2c4820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c4820",
  null
  
)

export default component.exports